import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useProfile } from '@lib/profile';
import { RESOLUTION_BREAKPOINT } from '@constants';
import { useIsMobile, useUpgradingAccount } from '@hooks';
const BasicLevelOutlet = () => {
    const navigate = useNavigate();
    const isSmallResolution = useIsMobile(RESOLUTION_BREAKPOINT.small);
    const { profile, investorBalance } = useProfile();
    const { pathname, state } = useLocation();
    const { renderInvestorPlansModal } = useUpgradingAccount();
    useEffect(() => {
        if (profile?.pendingCorrectionRequests.hasAddressProofRenewalRequest()
            && !profile.identification.hasInconsistentData()) {
            navigate('/perfil/documentos-rechazados');
            return;
        }
        if (state?.from?.pathname) {
            navigate(state?.from.pathname);
            return;
        }
        if (pathname !== '/') {
            return;
        }
        if (profile?.status.isCorrectingData()) {
            navigate('/perfil');
        }
        else if (profile?.hasRejectedDocs()) {
            navigate('/perfil/documentos-rechazados');
        }
        else if (profile?.accountLevel?.isFrozen()) {
            renderInvestorPlansModal();
            navigate('/marketplace');
        }
        else if (investorBalance?.hasInvested()) {
            if (isSmallResolution) {
                navigate('/home');
            }
            else {
                navigate('/marketplace');
            }
        }
        else {
            navigate('/onboarding');
        }
    }, [pathname, profile]);
    return (_jsx(Outlet, {}));
};
export default BasicLevelOutlet;
